import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { GoogleMaps } from '@grandvisionhq/common';

const LocationSearchMap = (_param)=> {
    var { className , labels , markers , activeLocation , mapOptions , highlightMarkerId , hovered , userLocation , userLocationZoomLevel , centerOnUserLocation , onClickUseMyLocation , onMarkerClick , onMarkerHover , onMapClick , center , markersUpdateConfig , id  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "markers",
        "activeLocation",
        "mapOptions",
        "highlightMarkerId",
        "hovered",
        "userLocation",
        "userLocationZoomLevel",
        "centerOnUserLocation",
        "onClickUseMyLocation",
        "onMarkerClick",
        "onMarkerHover",
        "onMapClick",
        "center",
        "markersUpdateConfig",
        "id"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('location-search-map', className)
    }), /*#__PURE__*/ React__default.createElement("style", {
        jsx: true,
        global: true
    }, `
        .gm-style .gm-style-iw-t:after {
          display: none;
        }

        .gm-style .gm-style-iw-c .gm-ui-hover-effect {
          display: none !important;
        }
      `), /*#__PURE__*/ React__default.createElement(GoogleMaps, {
        id: id,
        center: center,
        labels: {
            shareCurrentLocation: labels.shareCurrentLocation
        },
        markers: markers,
        highlightMarkerId: highlightMarkerId,
        hovered: hovered,
        mapOptions: mapOptions,
        showUseMyLocation: true,
        userLocation: userLocation,
        userLocationZoomLevel: userLocationZoomLevel,
        centerOnUserLocation: centerOnUserLocation,
        markersUpdateConfig: markersUpdateConfig,
        onClickUseMyLocation: onClickUseMyLocation,
        onMarkerClick: onMarkerClick,
        onMarkerHover: onMarkerHover,
        onMapClick: onMapClick
    }), activeLocation && /*#__PURE__*/ React__default.createElement("div", {
        className: "location-search-map__active-location"
    }, activeLocation // we render the active location outside the GoogleMaps on mobile
    ));
};
var LocationSearchMap$1 = LocationSearchMap;

export { LocationSearchMap$1 as default };
//# sourceMappingURL=LocationSearchMap.js.map
